//https://dev.to/ycmjason/here-is-a-little-script-to-grab-a-list-of-all-font-names-on-google-fonts--4b81
// Here I filter ther most common fonts
export const googleFonts = [
  "Alegreya",
  "Alegreya SC",
  "Alegreya Sans",
  "Alegreya Sans SC",
  "Muli",
  "Titillium Web",
  "Varela",
  "Varela Round",
  "Volkhov",
  "Vollkorn",
  "Vollkorn SC",
  "IBM Plex Mono",
  "IBM Plex Sans",
  "IBM Plex Sans Condensed",
  "IBM Plex Serif",
  "Crimson Text",
  "Cairo",
  "BioRhyme",
  "BioRhyme Expanded",
  "Karla",
  "Lora",
  "Frank Ruhl Libre",
  "Playfair Display",
  "Playfair Display SC",
  "Archivo",
  "Archivo Black",
  "Archivo Narrow",
  "Spectral",
  "Spectral SC",
  "Fjalla One",
  "Roboto",
  "Roboto Condensed",
  "Roboto Mono",
  "Roboto Slab",
  "Montserrat",
  "Montserrat Alternates",
  "Montserrat Subrayada",
  "Rubik",
  "Rubik Mono One",
  "Source Code Pro",
  "Source Sans Pro",
  "Source Serif Pro",
  "Cardo",
  "Cormorant",
  "Cormorant Garamond",
  "Cormorant Infant",
  "Cormorant SC",
  "Cormorant Unicase",
  "Cormorant Upright",
  "Work Sans",
  "Rakkas",
  "Concert One",
  "Yatra One",
  "Arvo",
  "Lato",
  "Abril Fatface",
  "Ubuntu",
  "Ubuntu Condensed",
  "Ubuntu Mono",
  "PT Mono",
  "PT Sans",
  "PT Sans Caption",
  "PT Sans Narrow",
  "PT Serif",
  "PT Serif Caption",
  "Old Standard TT",
  "Oswald",
  "Poppins",
  "Fira Mono",
  "Fira Sans",
  "Fira Sans Condensed",
  "Fira Sans Extra Condensed",
  "Nunito",
  "Nunito Sans",
  "Oxygen",
  "Oxygen Mono",
  "Exo",
  "Exo 2",
  "Open Sans",
  "Open Sans Condensed",
  "Merriweather",
  "Merriweather Sans",
  "Noto Sans",
  "Noto Sans HK",
  "Noto Sans JP",
  "Noto Sans KR",
  "Noto Sans SC",
  "Noto Sans TC",
  "Noto Serif",
  "Noto Serif JP",
  "Noto Serif KR",
  "Noto Serif SC",
  "Noto Serif TC",
  "GTWalsheimProRegular"
]
googleFonts.sort()


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/ToolbarContainer/ToolbarOptions/FontFamilyDropdown/googleFonts.js